import { handleActions } from 'redux-actions';

import { type resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './achievementsActions';
import type { AchievementProps } from './achievementsTypes';
import { mkAchievementsStore } from './achievementsTypes';

const achievementsReducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<AchievementProps>,
  ReturnType<typeof actions.getAchievementsSuccess> | ReturnType<typeof actions.getAchievementsFailure>
>(
  {
    [actions.getAchievementsSuccess.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getAchievementsFailure.type]: (state, { payload }) => resourceUpserters.completeWithError(state, payload),
  },
  mkAchievementsStore(),
);

export default achievementsReducer;
